<app-sidenav #sidenav></app-sidenav>

<cui-navbar #navbar>
  <h1>Hjælp</h1>

  <button mat-icon-button (click)="sidenav.open()" class="open-sidenav">
    <mat-icon svgIcon="nav/menu"></mat-icon>
  </button>
  <span class="fill"></span>
  <button class="toc" mat-icon-button (click)="navbar.toggle()">
    <mat-icon [svgIcon]="navbar.isOpen ? 'nav/close-black' : 'nav/content'"></mat-icon>
  </button>

  <cui-navbar-panel>
    <h1 (click)="goTo('Om')">Om</h1>
    <h2 (click)="goTo('Generelt')">Generelt</h2>
    <h2 (click)="goTo('Kom-igang')">Kom igang</h2>
    <h2 (click)="goTo('Gem-lister-og-direkte-adgang')">Gem lister og direkte adgang</h2>
    <h2 (click)="goTo('Log-ud')">Log ud</h2>
    <h2 (click)="goTo('Mistet-netvaerksforbindelse')">Mistet netværksforbindelse</h2>
    <h1 (click)="goTo('Pluklister')">Pluklister</h1>
    <h2 (click)="goTo('Soegning')">Søgning</h2>
    <h2 (click)="goTo('Resultater')">Resultater</h2>
    <h2 (click)="goTo('Haandter-reservationer')">Håndter Reservationer</h2>
    <h1 (click)="goTo('Soeg-materialer')">Søg materialer</h1>
    <h2 (click)="goTo('Soegning-materialer')">Søgning</h2>
    <h2 (click)="goTo('Resultater-materialer')">Resultater</h2>
    <h2 (click)="goTo('Haandter-materialer')">Håndter Materialer</h2>
  </cui-navbar-panel>
</cui-navbar>

<cui-user-manual>
  <h1 id="Om">Om</h1>

  <h2 id="Generelt">Generelt</h2>

  <p>
    I Cicero Move kan du online fremsøge pluklister og agere på de enkelte reservationer i realtid, således minimeres
    dobbeltarbejde med hensyn til pluklister. Endvidere er det muligt at markere materialer som værende "Ikke fundet".
    De materialer som er blevet markeret som "Ikke fundet" kan efterfølgende fremsøges på en liste hvor du kan vurdere
    om de kan findes eller de skal meldes bortkommet.

    <br> <br>
    En anden klar fordel ved Cicero Move er, at du i dine fremsøgte lister kan se bøgernes forsider, hvilket kan være
    en stor hjælp for dig.
    <br> <br>
    Cicero Move er en webbaseret klient, som er udviklet til tablets og mobiler med styresystemerne Android og iOS.
    Der understøttes nyeste version af disse browsere:
  </p>
  <ul>
    <li>Chrome på Android</li>
    <li>Safari på iOS</li>
  </ul>
  <p>
    Bemærk, Safari på iOS bliver kun opdateret sammen med systemopdateringer, hvorfor det er den nyeste version af iOS
    som understøttes.
  </p>
  <hr>


  <h2 id="Kom-igang">Kom igang</h2>
  <p>
    Du kan tilgå dit biblioteks Cicero Move på følgende adresse:
  </p>
  <ul>
    <li>http://move.cicero-suite.com/move/agency/DK-<span class="placeholder">Jeres agency-nummer</span>/login</li>
  </ul>
  <p>
    Her skal <span class="placeholder">jeres agency-nummer</span> byttes ud med det agency-nummer I har f.eks. 761500 for Horsens eller 715700
    for Gentofte.
    <br> <br>
    Når du lander på den ovenstående web-adresse vil du blive mødt af Cicero Move’s loginside. Her benyttes samme
    brugernavn og kodeord som du anvender i Cicero LMS til at logge ind i Cicero Move.
    <br> <br>
    Bemærk, det er vigtigt, at tiden på din enhed er indstillet korrekt ellers kan du ikke logge ind.
    <br> <br>
    Når du logger ind vil du se pluklistesøgningen. For at tilgå den øvrige funktionalitetet skal du trykke på
    <img src="./assets/user-manual/Burger Menu.svg" width="22"> oppe i venstre hjørne.
  </p>

  <hr>

  <h2 id="Gem-lister-og-direkte-adgang">Gem lister og direkte adgang</h2>

  <p>
    Cicero Move anvender dybe links dvs., at du i din browser kan bogmærke hvilken som helst liste eller side i applikationen
    og derved få direkte adgang til den via bogmærket, således du ikke skal indtaste søgekriterierne hver gang du vil tilgå en specifik plukliste.
    Hvis du f.eks. har lavet en liste du gerne vil genbruge hver dag, kan du bogmærke denne liste. Næste gang du skal anvende listen trykker
    du på bogmærket og du vil få den opdaterede liste ud fra søgekriterierne.
    <br><br>
    Endvidere giver dette også mulighed for at
    dele lister mellem enheder. Her kan du kopiere URL'en og sende den til den anden enhed. Således kan du sikre dig,
    at den anden enhed anvender nøjagtig samme liste.
    <br><br>
    Anvender du dybe links, og du ikke er logget ind, vil du blive bedt om at logge ind før du kan se siden.
    <br><br>
    Hvis du ønsker det kan du selvfølgelig bogmærke flere forskellige lister og sider i applikationen.
    <br><br>
    Ønsker du hurtigere adgang, kan du i stedet føje linket fra browseren til startskærmen på din enhed:
  </p>
  <img style="width: 45%;" src="./assets/user-manual/iosStart.png" class="large">
  <p>
    Dette understøttes både af Android og iOS.

  </p>

  <hr>

  <h2 id="Log-ud">Log ud</h2>

  <p>
    For at logge ud skal du trykke på <img src="./assets/user-manual/Burger Menu.svg" width="22"> oppe i venstre hjørne og derefter trykke på "Log ud".
    <br><br>
    Hvis ikke du logger ud, vil din enhed være indlogget i op til 12 timer, hvorefter den automatisk vil blive logget ud.

  </p>
  <hr>

  <h2 id="Mistet-netvaerksforbindelse">Mistet netværksforbindelse</h2>

  <p>
    Når du mister forbindelsen til netværket, kan du stadig bruge dine lister.
    Offline tilstand markeres med en orange bjælke i toppen af siden, som advarer dig, når du ikke er forbundet til netværket.
  </p>
  <img src="./assets/user-manual/Connection lost.png" class="large">

  <p>
    Når du får forbindelse til netværket igen vil dine og andres handlinger blive synkroniseret.
    Tilbagevenden til online tilstand markeres ved, at en grøn bjælke vises i stedet for den orange.
  </p>
  <img src="./assets/user-manual/Connection regained.png" class="large">

  <p>
    Bemærk, hvis listen forlades, vil de handlinger du har foretaget dig uden netværksforbindelse gå tabt.
  </p>


  <hr>

  <h1 id="Pluklister">Pluklister</h1>

  <h2 id="Soegning">Søgning</h2>

  <p>Ved opstart af Cicero Move vises søgning af pluklister automatisk (såfremt Move ikke startes via et dybt link). Søgningen
    kan også tilgås via menuen og efterfølgende tryk på "Pluklister".
    <br><br>
    Du kan søge en plukliste ud fra de kriterier som kan ses på skærmbilledet herunder:

  </p>

  <img src="./assets/user-manual/Search pick up list.png" class="large">

  <p>
    Feltet "Filial" kan ikke fravælges og skal være udfyldt. De andre felter er valgfrie og der kan vælges
    mere end en. Hvis du f.eks. kun er interesseret i nogle specifikke materialegrupper kan du i feltet "Materialegruppe" vælge de materialegrupper
    som du er interesseret i.
    <br><br>
    Felterne, der har med placering at gøre vises i Cicero Move i kort format. Placeringernes korte format kan ændres
    i Cicero LMS.
    <br><br>
    Når du trykker på "Søg" startes søgning og du bliver ført til din plukliste. Trykker du på "Nulstil" sættes søgningen
    tilbage til udgangspunktet.

  </p>


  <hr>

  <h2 id="Resultater">Resultater</h2>

  <p>
    En plukliste vises således:
  </p>
  <img src="./assets/user-manual/Pick-up List.png" class="large">

  <p>
    Listen er sorteret, i prioriteret rækkefølge, efter:
  </p>
  <ol>
    <li>Placering</li>
    <li>Klassemærke (DK5)</li>
    <li>Forfatter</li>
    <li>Titel</li>
  </ol>

  <p>
    I hver en række vises én reservation. Til venstre vises posten forsidebillede <img src="./assets/user-manual/Point1.png" width="22px">, hvis dette er tilgængeligt. Hvis et
    billede ikke vises, vises et ikon for materialetypen.
    Bemærk, for at få vist forsidebilleder skal det være sat korrekt op for Cicero LMS.
    <br><br>
    I første linje vises klassemærke, materialetypen med et ikon <img src="./assets/user-manual/Point2.png" width="22px"> og alderen på reservationen indikeret med farven <img
    src="./assets/user-manual/Point3.png" width="22px">.
    Ikonet for materialetypen bestemmes ud fra felt 009*a. Materialetypeikonerne
    beskriver følgende i felter 009*a:
  </p>
  <ul style="list-style:none;">
    <li><img src="./assets/user-manual/icons-14x14/Book.svg" height="14"> : a tekst, b håndskrift, p punktskrift</li>
    <li><img src="./assets/user-manual/icons-14x14/Sound.svg" height="14"> : c musikalier, d musikalier, r lydoptagelse, s musikoptagelse</li>
    <li><img src="./assets/user-manual/icons-14x14/Video.svg" height="14"> : m levende billeder</li>
    <li><img src="./assets/user-manual/icons-14x14/Images.svg" height="14"> : g billede</li>
    <li><img src="./assets/user-manual/icons-14x14/Sammensat materiale.svg" height="14"> : v sammensat materiale</li>
    <li><img src="./assets/user-manual/icons-14x14/Electronic.svg" height="14"> : t elektronisk materiale</li>
    <li><img src="./assets/user-manual/icons-14x14/Map.svg" height="14"> : e kartografisk materiale, f kartografisk materiale</li>
    <li><img src="./assets/user-manual/icons-14x14/Objects.svg" height="14"> : u genstand</li>
  </ul>
  <p>
    Til højre i første række er der en farve som indikerer alderen på reservation, dvs. den dato hvor reservationen er
    oprettet. Farverne indikerer følgende:
  </p>
  <ul style="list-style:none;">
    <li><img src="./assets/user-manual/icons-14x14/GreenIndicator.svg" height="8"> Reservationen er 0-2 dage gammel.</li>
    <li><img src="./assets/user-manual/icons-14x14/OrangeIndicator.svg" height="8"> Reservationen er 3-4 dage gammel.</li>
    <li><img src="./assets/user-manual/icons-14x14/RedIndicator.svg" height="8"> Reservationen er 5 dage gammel eller ældre.</li>
  </ul>
  <p>
    I anden linje vises forfatter, dog hvis det er en reservationen på et tidsskrift eller periodika vil periodikaoplysninger
    i form af; vol., nr og årstal for det pågældende periodika vises istedet for forfatter <img src="./assets/user-manual/Point4.png" width="22px">. I tredje og fjerde linje vises
    postens fulde titel <img src="./assets/user-manual/Point5.png" width="22px">. Femte linje viser FAUST-nummeret og evt. materialenummeret (hvis det er en reservation på et
    materialenummer),
    antal sider (hvis det er en bog) og udgaven <img src="./assets/user-manual/Point6.png" width="22px">.

    <br><br>
    I sjette linje vises hvor posten kan findes <img src="./assets/user-manual/Point7.png" width="22px">. Denne placering udregnes ud
    fra det første materiale som er hjemme inden for dine søgekriterier. Dvs. selvom der står en placering kan materialet
    muligvis godt findes på andre placeringer indenfor dine søgekriterier. Du kan få information om evt. andre placeringer ved at trykke
    på posten, hvor der efterfølgende åbnes et vindue med detaljer for samtlige materialer indenfor dine søgekriterier, som er hjemme.
  </p>

  <h3>Udvidet detaljer</h3>

  <p>For at se yderligere detaljer om en reservation kan du trykke på den. I dette overblik får du udover den information
    der vises i listen, den præcise reservationsdato, de materialer som findes på posten inden for dine søgekriterier og
    som er hjemme. For materialerne vises dets placering, materialer, hvornår det er afleveret og hvilket login det er
    er afleveret på:
  </p>
  <img src="./assets/user-manual/Expanded.png" class="large">

  <h3>Filtrering</h3>

  <p>
    For at filtrere din søgning yderligere kan du trykke på "Filtrer" i toppen til højre:
  </p>

  <img src="./assets/user-manual/Filter.png" class="large">

  <p>
    I første linje vises antal fremsøgte reservationer. Derudover har du en række muligheder for at ændre listen:
  </p>

  <ul>
    <li>"Skjul behandlede" vil gøre, at de behandlede reservationer i Move ikke kan ses. Du kan altid slå denne fra igen for at se de behandlede.</li>
    <li>"Vis detaljer for alle" vil vise alle de detaljer som er tilgængelige fra udvidet detaljer (se over).</li>
    <li>"Sortering efter reservationsdato" vil sortere resultaterne efter farveindikatorerne for alderen af reservationerne som 1. prioritet.</li>
  </ul>


  <hr>
  <h2 id="Haandter-reservationer">Håndter reservationer</h2>

  <p>
    En reservation kan håndteres på tre måder:
  </p>
  <ul style="list-style:none;">
    <li>Fundet</li>
    <ul>
      <li>Dette markerer reservationen på din liste og alle andres nuværende lister, som reservationen måtte optræde på, som værende fundet.
        På nye lister lavet efter markering vil den ikke optræde. Fra at du markerer den som "Fundet" kan der gå op til
        fem sekunder før den er markeret på de andre pluklister. Hvert andet minut tjekker Cicero Move om reservationen
        er blevet opfyldt gennem Cicero LMS eller selvbetjeningsautomaterne. Bliver en reservation opfyldt bliver den
        markeret som fundet i din aktive plukliste.
      </li>
    </ul>
    <li>Ikke fundet</li>
    <ul>
      <li>Markerer kun reservationen på din enhed og tildeler tema til de materialer som kan opfylde
        reservationen og som står på dens placering. Temaet som bliver
        tildelt til materialerne sættes op i Cicero LMS. Det anbefales at der tilknyttes et tema, som har en "ikke-reserverbar" materialegruppe.
        På denne måde vil disse materialer ikke forekomme på nye lister. Vejledningen til denne opsætning er beskrevet i
        installationsvejledningen til Cicero Move.
      </li>
    </ul>
    <li>Spring over</li>
    <ul>
      <li>Markeringen "Spring over" sker kun lokalt på din enhed. Laver du en ny plukliste vil reservationen ikke
        længere være markeret.
      </li>
    </ul>
  </ul>

  <p>
    For at markere en reservation som værende "Fundet" skal du fra listen swipe reservationen mod venstre. Når baggrunden skifter til blå og
    du slipper, vil reservation være markeret som "Fundet":
  </p>
  <img src="./assets/user-manual/Pick-up List Swipe 0.png" class="large">
  <img src="./assets/user-manual/Pick-up List Swipe 1.png" class="large">
  <p>
    For at markere en reservation som værende "Ikke fundet" eller "Spring over",
    skal du swipe mod højre og derefter trykke på en af de to knapper alt efter hvad du ønsker at gøre.
  </p>
  <img src="./assets/user-manual/Pick-up List Swipe 3.png" class="large">
  <p>
    Du kan også markere en reservation direkte fra detaljevisningen ved at trykke på en af knapperne i bunden af vinduet.
  </p>
  <img src="./assets/user-manual/Expanded.png" class="large">

  <p>Det er muligt at fortryde handlinger. I listen gøres dette ved et swipe til enten højre
    eller venstre på en markeret reservation. Fra detaljevisningen kan du trykke på knappen "Fortryd".
    <br> <br>
    Du kan ikke fortryde handlinger foretaget af andre.
  </p>

  <hr>

  <h1 id="Soeg-materialer">Søg materialer</h1>

  <h2 id="Soegning-materialer">Søgning</h2>

  <p>
    I denne funktionalitet kan du søge efter materialer. Her er det specielt tiltænkt, at du
    kan fremsøge og håndtere materialer, som er blevet markeret som værende "Ikke fundet" i pluklisten. I søgeindstillingerne
    er det derfor som standard sat til at søge efter materialer, som har tilknyttet dit "Ikke fundet"-tema.
    <br><br>
    Du kan søge materialer ud fra de kriterier som kan ses på skærmbilledet herunder:
  </p>
  <img src="./assets/user-manual/Search materials.png" class="large">
  <p>
    Alle felter er valgfrie og der kan vælges mere end et. Et felt skal dog udfyldes for, at du kan udføre en søgning.
    Felterne der har med placering at gøre, vises i Cicero Move i kort format. Placeringernes korte format kan ændres i Cicero LMS.
    <br><br>
    Når du trykker på "Søg" startes søgning og du bliver ført til din søgning. Trykker du på "Nulstil" sættes søgningen tilbage til udgangspunktet.
  </p>
  <hr>

  <h2 id="Resultater-materialer">Resultater</h2>
  <p>
    En søgning af materialer vises således:
  </p>
  <img src="./assets/user-manual/Search Materials list.png" class="large">
  <p>
    I hver række vises ét materiale. Til venstre vises et billede, hvis dette er tilgængeligt, hvis ikke vises, der er et ikon for materialetypen <img
    src="./assets/user-manual/Point1.png" width="22px">.
    Bemærk, for at få vist forsidebilleder skal det være sat korrekt op for Cicero LMS.
    <br><br>
    I første linje vises klassemærkningen og et ikon for materialetypen <img src="./assets/user-manual/Point2.png" width="22px">.
    Materialetypeikonerne beskriver følgende i felter 009*a:
  </p>
  <ul>
    <li><img src="./assets/user-manual/icons-14x14/Book.svg" height="14"> : a tekst, b håndskrift, p punktskrift</li>
    <li><img src="./assets/user-manual/icons-14x14/Sound.svg" height="14"> : c musikalier, d musikalier, r lydoptagelse, s musikoptagelse</li>
    <li><img src="./assets/user-manual/icons-14x14/Video.svg" height="14"> : m levende billeder</li>
    <li><img src="./assets/user-manual/icons-14x14/Images.svg" height="14"> : g billede</li>
    <li><img src="./assets/user-manual/icons-14x14/Sammensat materiale.svg" height="14"> : v sammensat materiale</li>
    <li><img src="./assets/user-manual/icons-14x14/Electronic.svg" height="14"> : t elektronisk materiale</li>
    <li><img src="./assets/user-manual/icons-14x14/Map.svg" height="14"> : e kartografisk materiale, f kartografisk materiale</li>
    <li><img src="./assets/user-manual/icons-14x14/Objects.svg" height="14"> : u genstand</li>
  </ul>
  <p>
    I anden linje vises forfatter <img src="./assets/user-manual/Point3.png" width="22px">. I tredje og fjerde linje vises postens fulde titel <img
    src="./assets/user-manual/Point4.png" width="22px">.
    Femte linje viser FAUST-nummeret
    og materialenummeret (med fed skrift),
    antal sider hvis det er en bog og udgaven <img src="./assets/user-manual/Point5.png" width="22px">.
    <br><br>
    I sjette linje vises hvor materialet burde kunne findes <img src="./assets/user-manual/Point6.png" width="22px">. Syvende linje viser den seneste handling samt hvornår
    og hvilken bruger handlingen er udført hos <img src="./assets/user-manual/Point7.png" width="22px">.
    <br><br>
    Hvis du kun vil se et af materialerne kan du trykke på det. Således åbnes der er et vindue hvor du kun får vist dette ene materiale.
  </p>

  <h3>Filtrering</h3>

  <p>
    For at filtrere din søgning yderligere kan du trykke på "Filtrer" i højre side i toppen af siden:
  </p>

  <img src="./assets/user-manual/Search Materials list Filter.png" class="large">

  <p>
    I første linje vises antal materialer som er fremsøgt. Derudover kan du via "Skjul behandlede" gøre,
    at de behandlede materialer ikke ses i listen. Du kan altid slå denne fra igen for at se de behandlede.
  </p>

  <hr>

  <h2 id="Haandter-materialer">Håndter materialer</h2>

  <p>
    Et materiale på denne liste kan håndteres på to måder:
  </p>

  <ul>
    <li>Fundet: Fjerner det tilknyttede tema fra materialet.</li>
    <li>Bortkommet: Sætter materialets status til status "Bortkommet".</li>
  </ul>

  <p>
    For at markere et materiale som værende "Fundet" skal du fra listen swipe materialet mod venstre. Når baggrunden skifter til blå og
    du slipper vil materialet blive markeret som "Fundet". Hvis materialet kan opfylde en reservation vil dette stå på skærmen
    efter materialet er blevet markeret som "Fundet".
  </p>
  <img src="./assets/user-manual/Search material list swipe1.png" class="large">
  <p>
    For at markere et materiale som "Bortkommet" skal du swipe mod højre.
  </p>
  <img src="./assets/user-manual/Search materials list Swipe2.png" class="large">
  <p>
    Du kan også håndtere et materiale direkte fra detaljevisningen af materialet ved at trykke på en af knapperne i bunden af vinduet.
  </p>
  <img src="./assets/user-manual/Search Materials list modal.png" class="large">
  <p>
    Det er muligt at fortryde handlinger foretaget af dig i din liste. I listen gøres dette ved at swipe til enten højre eller venstre. Fra
    detaljevisningen kan du trykke på knappen "Fortyd".
  </p>


  <hr>
</cui-user-manual>



// WEBPACK FOOTER //
// ./src/app/help/user-manual/user-manual.component.html